export default __webpack_public_path__ + "static/media/19.a7c99624.png";